import { connect } from 'react-redux'

import * as questionnaireAdminActions from '../../ducks/questionnaire-admin'
import GroupRoles from '../GroupRoles'

function mapStateToProps(state) {
  return {
    currentLanguage: state.account.get('currentLanguage'),
    questionnaireUuid: state.questionnaireAdmin.get('questionnaireUuid'),
    questionnaires: state.questionnaireAdmin.get('questionnaires'),
    deletedInvitations: state.questionnaireAdmin.get('deletedInvitations'),
    searchFilters: state.questionnaireAdmin.get('searchFilters'),
    pagination: state.questionnaireAdmin.get('pagination'),
    sentInvitations: state.questionnaireAdmin.get('sentInvitations'),
    showOnlyOwnQuestionnaires: state.questionnaireAdmin.get('showOnlyOwnQuestionnaires'),
    token: window.localStorage.getItem('token')
  }
}

export default connect(mapStateToProps, {
  onSearch: questionnaireAdminActions.search,
  onDeleteInvitation: questionnaireAdminActions.deleteInvitation,
  onShowOnlyOwnQuestionnaires: questionnaireAdminActions.setShowOnlyOwnQuestionnaires
})(GroupRoles)



// WEBPACK FOOTER //
// ./src/components/smart/GroupRolesContainer.js